import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.css']
})
export class SubmissionsComponent implements OnInit {
  @ViewChild('myFCPond')           myFCPond: any;
  @ViewChild('MR_Pond')            MR_Pond: any;
  @ViewChild('Writer_Pond_Attach') Writer_Pond_Attach: any;
  @ViewChild('Writer_Pond_Plag')   Writer_Pond_Plag: any;

  public activeUser: any;
  public browserSub: any;
  public despositionArray: any = AppSettings.disposition;
  public documentTypeArray: any = AppSettings.documentType;
  public orderStatus: any = AppSettings.orderStatus;
  public clientFeedback: any = AppSettings.clientFeedback;
  public subStatus: any = [{ name: 'Late Submissions', value: 'late' }, { name: 'In-Time Submissions', value: 'in-time' }];
  public loading: any = false;
  public loadingWriters: any = false;
  public paginatePage: any;
  public leads: any = [];
  public leadIndex: any = null;
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public agentsSub: any;
  public agents: any;
  public qa: any;
  public loader: any;
  public qaLoader: any;
  public all_users: any;
  public writers: any;
  public bonusLeadIndex: any;
  public bonusLoader: any = false;
  public cbLoader                : any = false;
  public submitted               : any = false;

  // Submit to Client Action Vars
  public DOC_URL                        : any = AppSettings.DOC_URL;
  public docs_submitted_complete_path   : any = AppSettings.docs_submitted_complete_path;
  public WR_SubWork                     : any = { document_note: '', attach: [], oldAttach: '', plag_report: [], oldPlag: '' };
  public WR_Index                       : any = null;
  public WR_ActionLoader                : any = false;
  public WR_FileLoader                  : any = false;

  public QA_Indx                 : any;
  public QA_Action               : any = { quality_note: '' };
  public QA_Loader               : any = false;
  public QA_Submitted            : any = false;

  public MR_Indx                 : any;
  public MR_Action               : any = { revision_note: '', attach: [] };
  public MR_Loader               : any = false;
  public MR_Submitted            : any = false;
  public lead_Index              : any;
  public loaderDelete            : any;
  public fileDeleted_loader      : any;

  public proofreaders           : any;

  public MR_pondOptions = {
    allowMultiple: true,
    labelIdle: ` <p class='pond-label'> Drag & drop or <span> browse </span></p>`,
    allowImagePreview: true,
    acceptedFileTypes: "image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf,",
    server: {
      url: AppSettings.API_ENDPOINT,
      timeout: 200000,
      process: {
        url: './admin/upload-temp-files',
        method: 'POST',
        withCredentials: false,
        timeout: 30000,
        onload: (response) => {
          let parsedData = JSON.parse(response);
          let decrptedImg = this.helperService.decrypted(parsedData.data);
          let image = JSON.parse(decrptedImg);
          // console.log("image",image);

          let id = image.id;

          // Add image to pro image array
          this.MR_Action.attach.push(id);
          this.fileUploadLoader = false;

          return id;
        },
        onerror: (response) => {
          return response.key;
        },
        ondata: (formData) => {
          this.fileUploadLoader = true;
          return formData;
        }
      },
      revert: (uniqueFileId, load, error) => {
        this.MR_Action.attach.splice(this.MR_Action.attach.indexOf(uniqueFileId), 1);

        // Clear Image
        load();
      },
      restore: null,
      load: null,
      fetch: null
    }
  };

  public WR_Attach_PondOptions = {
      allowMultiple: true,
      labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
      allowImagePreview: true,
      maxFileSize: '5MB',
      imagePreviewMaxFileSize: '5MB',
      // stylePanelLayout: 'compact circle',
      server: {
          url: AppSettings.API_ENDPOINT,
          timeout: 200000,
          process: {
              url: './admin/upload-temp-files',
              method: 'POST',
              withCredentials: false,
              timeout: 30000,
              onload: (response) => {
                // Hide File Upload Loader
                this.WR_FileLoader = false;

                let parsedData = JSON.parse(response);
                let decrptedImg = this.helperService.decrypted(parsedData.data);
                let image = JSON.parse(decrptedImg);

                // Add image to pro image array
                this.WR_SubWork.attach.push(image.id);

                return image.id;
              },
              onerror: (response) => {
                  return response.key;
              },
              ondata: (formData) => {
                  // Show File Upload Loader
                  this.WR_FileLoader = true;

                  return formData;
              }
          },
          revert: (uniqueFileId, load, error) => {
              // Rmeove from array
              this.WR_SubWork.attach.splice(this.WR_SubWork.attach.indexOf(uniqueFileId), 1);

              // Clear Image
              load();
          },
          restore : null,
          load    : null,
          fetch   : null
      }
  };

  public WR_Plag_PondOptions = {
      allowMultiple: true,
      labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
      allowImagePreview: true,
      maxFileSize: '5MB',
      imagePreviewMaxFileSize: '5MB',
      // stylePanelLayout: 'compact circle',
      server: {
          url: AppSettings.API_ENDPOINT,
          timeout: 200000,
          process: {
              url: './admin/upload-temp-files',
              method: 'POST',
              withCredentials: false,
              timeout: 30000,
              onload: (response) => {
                // Hide File Upload Loader
                this.WR_FileLoader = false;

                let parsedData = JSON.parse(response);
                // console.log("response.data******", response.data);
                let decrptedImg = this.helperService.decrypted(parsedData.data);
                let image = JSON.parse(decrptedImg);

                // Add image to pro image array
                this.WR_SubWork.plag_report.push(image.id);

                return image.id;
              },
              onerror: (response) => {
                  return response.key;
              },
              ondata: (formData) => {
                  // Show File Upload Loader
                  this.WR_FileLoader = true;

                  return formData;
              }
          },
          revert: (uniqueFileId, load, error) => {
              // Rmeove from array
              this.WR_SubWork.plag_report.splice(this.WR_SubWork.plag_report.indexOf(uniqueFileId), 1);

              // Clear Image
              load();
          },
          restore : null,
          load    : null,
          fetch   : null
      }
  };

  public bonusPercent: any = ['-100', '-60', '-50', '-30', '-25', '-20', '-15', '-10', '0', '+10', '+15', '+20', '+25', '+30', '+50', '+60', '+100']
  public bonus: any = { bonus_ded: null, note: '' }
  public bonusForm: FormGroup;
  public firstCopyForm: FormGroup;
  public chargeBackForm: FormGroup;

  public FC_Index      : any = null;
  public firstCopyData : any = { payment_link: '', document_note: '', files: [], oldAttachments: '' };

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = { order_id: '', work_type: '', orderStatus: null, order_type: null, writer: null, date_from: '', date_to: '', client_feedback: null };
  public fullRangeDate: any;
  public selectedDesposition: any;
  public fileUploadLoader: any = false;
  public chargeBack_id: any;
  public chargeBack_Indx: any;
  public chargeBackData: any = { cb_amount: '', cb_note: '' }
  public notes         : any = '';
  public addNoteId     : any;
  public addingNote    : any = false;
  public addNoteIndex: any;
  public deletingLead_Index: any;
  public feedbackNote: any;
  public chargeAttachments: any = [];

  public firstCopyPondOpts = {
    allowMultiple: true,
    labelIdle: ` <p class='pond-label'> Drag & drop or <span> browse </span></p>`,
    allowImagePreview: true,
    acceptedFileTypes: "image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf,",
    server: {
      url: AppSettings.API_ENDPOINT,
      timeout: 200000,
      process: {
        url: './admin/upload-temp-files',
        method: 'POST',
        withCredentials: false,
        timeout: 30000,
        onload: (response) => {
          let parsedData = JSON.parse(response);
          // console.log("response.data******", response.data);
          let decrptedImg = this.helperService.decrypted(parsedData.data);
          let image = JSON.parse(decrptedImg);
          // console.log("image",image);

          // let name  = image.name;
          let id = image.id;
          // Add image to pro image array
          this.firstCopyData.files.push(id);
          this.fileUploadLoader = false;
          return id;
        },
        onerror: (response) => {
          return response.key;
        },
        ondata: (formData) => {
          this.fileUploadLoader = true;
          return formData;
        }
      },
      revert: (uniqueFileId, load, error) => {
        this.firstCopyData.files.splice(this.firstCopyData.files.indexOf(uniqueFileId), 1);

        // Clear Image
        load();
      },
      restore: null,
      load: null,
      fetch: null
    }
  }
  pondFiles = []

  constructor(
    private authenticationService: AuthenticationService,
    private helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private agentsService: Agents,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {

    this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
      if (isBrowser) {
        // Get Agents
        this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
          if (agents) {
            this.all_users    = agents.all_users;
            this.agents       = agents.agents;
            this.qa           = agents.qa;
            this.writers      = agents.writers;
            this.proofreaders = agents.proofreaders;
          }
        });

        this.activeUser = this.authenticationService.get_currentUserValue();

        this.dtOptions = {
          paging: true,
          info: true,
          // ordering: false,
          pagingType: 'full_numbers',
          pageLength: 25,
          serverSide: true,
          processing: true,
          searching: false,
          'language': AppSettings.dataTableLang,
          "columnDefs": [
            { "orderable": false,     "targets": 0 },
            { "orderable": false,     "targets": 1 },
            { "orderable": false,     "targets": 2 },
            { "orderable": false,     "targets": 3 },
            { "orderable": false,     "targets": 4 },
            { "orderable": false,     "targets": 5 },
            { "orderable": false,     "targets": 6 },
            { "orderable": false,     "targets": 7 },
            { "orderable": false,     "targets": 8 },
            { "orderable": false,     "targets": 9 },
            { "orderable": false,     "targets": 10 },
            { "orderable": false,     "targets": 11 },
          ],
          "order": [[0, "desc"]],
          ajax: (dataTablesParameters: any, callback) => {
            // Show Loader
            this.loading = true;
            // console.log("dataTablesParameters", dataTablesParameters);

            let url = AppSettings.API_ENDPOINT + 'writers/submissions';

            let dtParams = {
              order_id          : this.searchParams.order_id,
              work_type         : this.searchParams.work_type,
              writer_id         : this.searchParams.writer,
              client_feedback   : this.searchParams.client_feedback,
              status            : this.searchParams.orderStatus,
              order_type        : this.searchParams.order_type,
              date_from         : this.searchParams.date_from ? this.helperService.convertDateToString(this.searchParams.date_from) : '',
              date_to           : this.searchParams.date_to ? this.helperService.convertDateToString(this.searchParams.date_to, false) : '',
              start             : dataTablesParameters.start,
              length            : dataTablesParameters.length,
              order             : dataTablesParameters.order,
              columns           : dataTablesParameters.columns
            };

            // For Record Serial Numbers
            this.paginatePage = dataTablesParameters.start;
            this.leads.data = [];
            this.helperService.httpPostRequestsDecryp(url, dtParams)
              .then(resp => {
                this.leads = JSON.parse(resp);
                // console.log("this.leads: ", this.leads);

                // Set Default page len
                this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                // Hide Loader
                this.loading = false;

                callback({
                  recordsTotal: this.leads.total,
                  recordsFiltered: this.leads.total,
                  // recordsFiltered: resp['recordsFiltered'],
                  // recordsFiltered: 1000,
                  data: []
                });

                // // $(".paginate_button .current").css("color", "white");
                // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                $('div.dataTables_length select').addClass('dt-form-control');
                $('div.dataTables_filter input').addClass('dt-form-control');
              })
              .catch(error => {
                // Set loader false
                this.loading = false;

                // // Rerender DT in case of failure
                // this.rerender();

                console.log("error: ", error);
              });
          },
          columns: [
            // { data: 'multiDelete' },
            { data: 'id' },
            { data: 'id' },
            { data: 'name' },
            { data: 'work_type' },
            { data: 'writer_due_date' },
            { data: 'writer_name' },
            { data: 'submission_date' },
            { data: 'attachments' },
            { data: 'quality' },
            { data: 'comments' },
            { data: 'feedback' },
            { data: 'feedback' },
          ],
          // Use this attribute to enable the responsive extension
          responsive: false
        }
      }
    });
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.activeUser.is_writermanager) {
      // Get writers first by Team
      this.getManagerTeam().then((resp) => {
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }

    this.rerender();
  }

  getManagerTeam(): Promise<any> {
    let self = this;
    return new Promise((resolve, reject) => {
      // Show Loader
      self.loadingWriters = true;

      let url = AppSettings.API_ENDPOINT + "writers/get-manager-team";

      self.helperService.httpPostRequestsDecryp(url, {}).then(resp => {
        this.writers = JSON.parse(resp).writerTeamArray;
        resolve(resp);

        // Hide loader
        self.loadingWriters = false;
      }).catch(err => {
        // Hide loader
        self.loadingWriters = false;

        resolve(err);
      });
    });
  }

  updateDesposition(lead, index) {
    let url = AppSettings.API_ENDPOINT + "admin/update-lead-status";
    let data = { id: lead.id, status: lead.status };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        // this.leads =
        // this.rerender();
      }
    });
  }

  updateAgent(lead, index) {
    console.log("lead", lead);

    let url = AppSettings.API_ENDPOINT + "admin/update-lead-agent";
    let data = { val: lead.agent_id, oid: lead.id };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined" && resp.status == "OK") {
        Swal.fire('', resp.message, 'success');
      }
      if (typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }
    });
  }

  download_WCO_Attach(wcoID, index) {
    // Show Zip loader
    this.leads.data[index].creatingZip = true;

    let url = AppSettings.API_ENDPOINT + "shared/create-wco-zip";
    let data = { id: wcoID };

    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined" && resp.status == 'OK') {
        window.open(resp.zip, '_blank');
      } else {
        Swal.fire('', resp.message, 'error');
      }

      // Hide Zip loader
      this.leads.data[index].creatingZip = false;
    }).catch(err => {
      // Hide Zip loader
      this.leads.data[index].creatingZip = false;
    });
  }

  showComments(lead, index) {
    // this.loader = true;
    // console.log("this.lead", lead);

    this.qaLoader = lead.id;

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { l: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        // console.log("resp", resp);
        this.comments = resp.data;
        this.agentComments = [];
        this.qaComments = [];

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == "Leads-Comments") {
            this.agentComments.push(this.comments[i]);
          }
          else if (this.comments[i].type == "QA-Leads-Comments") {
            this.qaComments.push(this.comments[i]);
          }
          else { }
        }


        if (this.agentComments.length == 0 && this.qaComments.length == 0) {
          Swal.fire('No comments', "Agents and QA haven't added any comment yet.", 'info');
          this.qaLoader = '';
        }
        else {
          if (typeof $ != "undefined") {
            this.qaLoader = '';
            $("#comment_modal").modal("show");
          }
        }
      }
    });
  }

  showWriterManagerComments(lead, index, type = '') {
    // Show Loader
    this.leads.data[index].comLoader = true;

    this.leadIndex = index;

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { o: lead.oid, type: type };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        this.comments = resp.data;
        this.qaComments = resp.data;

        if (this.qaComments.length == 0 && this.leads.data[this.leadIndex].document_note == '') {
          Swal.fire('No comments', "No QA and Document notes found.", 'info');
        }
        else {
          if (typeof $ != "undefined") {
            // $("#comment_modal").modal("show");
            // Show Comment popup
            $("#wm_comment_modal_" + index + "").modal("show");
          }
        }
      }

      // Hide Loader
      this.leads.data[index].comLoader = false;
    }).catch(err => {
      // Hide Loader
      this.leads.data[index].comLoader = false;
    });
  }

  getCustomerFeedbackForWriter(index, oid, wid) {
    // Show loader
    this.leads.data[index].loadingFeed = true;

    let url = AppSettings.API_ENDPOINT + "shared/get-client-feedback-by-order-writer";
    let data = { order_id: oid, writer_id: wid };

    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        this.comments = resp.data;

        if (this.comments.length == 0) {
          Swal.fire('No Feedback Available', "", 'info');
        }
        else {
          if (typeof $ != "undefined") {
            // Show Popup
            $("#wrFeedBack_modal" + index).modal("show");
          }
        }
      }

      // Hide loader
      this.leads.data[index].loadingFeed = false;
    }).catch(err => {
      // Hide loader
      this.leads.data[index].loadingFeed = false;
    });
  }

  showFeedback(lead, index, type){
    // Show loader
    this.leads.data[index].loadingFeed = true;
    this.lead_Index                    = index;

    this.loader = lead.id;

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { o: lead.oid, type: type };
    this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined") {
          this.comments      = resp.data;

          if (this.comments.length == 0) {
            Swal.fire('No comments', "Comments are not added yet." , 'info');
          }
          else {
            if (typeof $ != "undefined") {
              for (let i = 0; i < this.comments.length; i++) {
                if(typeof this.comments[i].notes.split('<strong>')[1] != 'undefined')
                  this.comments[i]['qaRating'] = parseFloat(this.comments[i].notes.split('<strong>')[1].split('</strong>')[0]);
              }

              // Show Popup
              $("#qaFeedBack_modal").modal("show");
            }
          }
        }

        // Hide loader
        this.leads.data[index].loadingFeed = false;
    }).catch(err => {
        // Hide loader
        this.leads.data[index].loadingFeed = false;
    });
  }

  parseFloat(value){
    return parseFloat(value);
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }

    return "";
  }

  pondHandleInit() {
    // console.log('FilePond has initialised');
  }

  pondHandleAddFile(event: any) {
    // console.log('A file was added', event);
  }

  pondHandleActivateFile(event: any) {
    // console.log('A file was activated', event)
  }

  clearFilters() {
    this.searchParams = { order_id: '', work_type: '', orderStatus: null, order_type: null, writer: null, date_from: '', date_to: '', client_feedback: null };
    this.fullRangeDate = "";

    this.rerender();
  }

}
